/**
 * 业务日历模块接口列表
 */
import Vue from "vue"
import axios from '@/utils/http'; // 导入http中创建的axios实例
const businessNotice = {
     //页面初始化
      init() {
        return axios.get(`${Vue.prototype.$base.API_PATH}/businessnotice/init`);
      },
     //编辑页面初始化
      editInit() {
        return axios.get(`${Vue.prototype.$base.API_PATH}/businessnotice/edit-init`);
      },
      //页面数据加载
      list(params) {
        return axios.get(`${Vue.prototype.$base.API_PATH}/businessnotice/list`, { params: params});
      },
      //查看通知详细信息
      detail(params) {
        return axios.get(`${Vue.prototype.$base.API_PATH}/businessnotice/detail`, { params: params});
      },
      //回复情况页面数据加载
      replylist(params) {
        return axios.get(`${Vue.prototype.$base.API_PATH}/businessnotice/replylist`, { params: params});
      },
      //供应商范围
      vendorlimit(params) {
        return axios.get(`${Vue.prototype.$base.API_PATH}/businessnotice/vendorlimit`, { params: params});
      },
      //更新供应商回复情况信息
      vendorreply(params) {
        return axios.put(`${Vue.prototype.$base.API_PATH}/businessnotice/reply`, params);
      },
      //添加新通知
      addnotice(params) {
        return axios.put(`${Vue.prototype.$base.API_PATH}/businessnotice`, params);
      },
      //删除通知
      deletenotice(params) {
        return axios.delete(`${Vue.prototype.$base.API_PATH}/businessnotice`, { params: params});
      },
      
}

export default businessNotice;



// WEBPACK FOOTER //
// ./src/api/businessNotice.js